import React from "react";
import { cn } from "../../lib/utils";

export interface ServiceStatus {
  vehicle_id: string; plate_number: string; tenant_id: string; tenant_name?: string | null;
  interval_km: number; interval_months: number; last_service_date?: string | null; last_service_km?: number | null;
  baseline_source?: "work_order" | "manual" | null; current_km?: number | null; odometer_source: "geotab" | "record";
  next_due_km?: number | null; next_due_date?: string | null; km_left?: number | null; days_left?: number | null;
  stage: "ok" | "due_soon" | "due_now" | "overdue" | "unknown"; label: string; trigger?: "mileage" | "time" | null;
  plan?: { interval_km?: number; interval_months?: number; last_service_date?: string; last_service_km?: number };
  settings?: ServiceSettings;
}
export interface ServiceSettings { tenant_id: string; interval_km: number; interval_months: number; warn_km: number; warn_days: number; email_enabled: boolean }

export const STAGE_STYLE: Record<ServiceStatus["stage"], string> = {
  ok: "bg-emerald-50 text-emerald-800 ring-emerald-200",
  due_soon: "bg-amber-50 text-amber-800 ring-amber-200",
  due_now: "bg-orange-50 text-orange-800 ring-orange-300",
  overdue: "bg-rose-50 text-rose-700 ring-rose-300",
  unknown: "bg-slate-100 text-slate-500 ring-slate-200",
};
export const STAGE_LABEL: Record<ServiceStatus["stage"], string> = { ok: "On track", due_soon: "Due soon", due_now: "Due now", overdue: "Overdue", unknown: "No baseline" };

export function serviceHint(s: Pick<ServiceStatus, "km_left" | "days_left" | "stage">): string {
  if (s.stage === "unknown") return "Set last service";
  const bits: string[] = [];
  if (s.km_left != null) bits.push(s.km_left < 0 ? `${Math.abs(s.km_left).toLocaleString()} km over` : `${s.km_left.toLocaleString()} km left`);
  if (s.days_left != null) bits.push(s.days_left < 0 ? `${Math.abs(s.days_left)}d over` : `${s.days_left}d left`);
  return bits.join(" · ") || "—";
}

export function ServiceBadge({ s, testId, withHint }: { s?: Pick<ServiceStatus, "stage" | "km_left" | "days_left"> | null; testId?: string; withHint?: boolean }) {
  if (!s) return <span className="text-[11px] text-slate-400">—</span>;
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      <span data-testid={testId} className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1", STAGE_STYLE[s.stage])}>{STAGE_LABEL[s.stage]}</span>
      {withHint && <span className="text-[10px] text-slate-500">{serviceHint(s)}</span>}
    </span>
  );
}
